export const createEmailId = (): string => {
  const random = Math.floor(Math.random() * 10000);
  return `${Date.now().toString()}${random}`;
};
